export const collabSidebarName = 'edit-post/collab-sidebar';
